<template>

	<a-card :bordered="false" class="widget-1">
		<a-statistic
			:title="title"
			:value="value"
			:prefix="prefix"
			:suffix="suffix"
			:precision="1"
			class="text-dark"
			:class="'text-dark'"
		>
		</a-statistic>
		<div class="icon text-center" :style="{ backgroundColor: '#ffffff' }">
			<img :src="image[index]" width="45" class="" alt="imag_cardQuota_1" />
		</div>
		
	</a-card>

</template>

<script>

	export default ({
		props: {
			title: {
				type: String,
				default: "",
			},
			index: {
				type: Number,
				default: 0,
			},
			value: {
				type: String,
				default: '',
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			icon: {
				type: String,
				default: "",
			},
			status: {
				type: String,
				default: "success",
			},
		},
		data() {
			return {
				image:[
					'./images/holiday-icon.png','./images/sick-icon-1.png','./images/sick-icon.png','./images/leave-icon.png',
				]
			}
		},

	})

</script>